import { Routes } from '@angular/router';
import { MyResourcesComponent } from './my-resources/my-resources.component';
import { CreateResourcesComponent } from './create-resources/create-resources.component';
import { AdminComponent } from './admin/admin.component';
import { combinedRoleGuard } from './_guards/combinedRoleGuard';
import { AllResourcesComponent } from './all-resources/all-resources.component';
import { ServerComponent } from './server/server.component';

export const routes: Routes = [
  { path: '', redirectTo: 'create-resources', pathMatch: 'full' },
  // {path: 'home', component: HomeComponent, data: {title: 'Home'}},
  {
    path: 'my-resources',
    component: MyResourcesComponent,
    canActivate: [combinedRoleGuard],
    data: { title: 'My Resources' },
  },
  {
    path: 'create-resources',
    component: CreateResourcesComponent,
    canActivate: [combinedRoleGuard],
    data: { title: 'Create Resources' },
  },
  {
    path: 'server',
    component: ServerComponent,
    canActivate: [combinedRoleGuard],
    data: { title: 'Server' },
  },
  {
    path: 'admin',
    component: AdminComponent,
    canActivate: [combinedRoleGuard],
    data: { title: 'Admin' },
  },
  {
    path: 'all-resources',
    component: AllResourcesComponent,
    canActivate: [combinedRoleGuard],
    data: { title: 'All Resources' },
  },
];
